<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal='false' width="700px">
    <el-form label-position="left" label-width="68px" size="mini">
      <el-row style="margin-bottom:0;">
        <el-col style="width:50%;">
          <el-form-item label="周  期" style="padding-right:10px;">
            <el-input v-model="form.period" auto-complete="off">
              <template slot="append">分</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col style="width:50%;">
          <el-form-item label="录音时长" style="padding-left:10px;">
            <el-input v-model="form.recording_length" auto-complete="off">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="任务说明">
        <el-input :rows="1" placeholder="请输入内容" v-model="form.detail" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="扫描频率">
        <template>
          <el-tag style="margin-right:1%" v-for="(value,key) in form.freq_range" :key="key" closable type="success" size="medium" @close="handleTagClose(key)">
            {{parseFreqRange(value)}}
          </el-tag>
          <div v-if="freqInputVisible" display="inline" style="margin:5px 0 0 0;padding:0;">
            <el-input-number style="width:120px" class="input-new-tag" ref="saveTagInput" size="mini" v-model="freqStart" controls-position="right"
              :min="87" :max="108" :precision="1" :step="0.1"></el-input-number>
            -
            <el-input-number style="width:120px" class="input-new-tag" ref="saveTagInput" size="mini" v-model="freqEnd" controls-position="right"
              :min="87" :max="108" :precision="1" :step="0.1"></el-input-number>
            <el-button style="margin-left:20px" type="primary" size="mini" @click="hideFreqInput">取消</el-button>
            <el-button type="primary" size="mini" @click="addFreq">确定</el-button>
          </div>
          <el-button v-else style="margin-left:20px" type="primary" size="mini" @click="freqInputVisible = true" round>添加频率</el-button>
        </template>
      </el-form-item>
      <el-form-item label="白名单">
        <el-table :data="allWhitelst" border :height="350" style="width:100%;margin-bottom:10px;" row-class-name="allWhitelstTable"
          header-row-class-name="allWhitelstTable" size="mini">
          <el-table-column width="70" align="center" :render-header="renderSelect" prop="checked" style="padding:0;">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" @change="handleCheckChange"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="frequency" label="频率" width="60">
          </el-table-column>
          <el-table-column prop="name" label="名称" sortable>
          </el-table-column>
          <el-table-column prop="area" label="地区" width="80" align="center">
          </el-table-column>
          <el-table-column label="录音" width="80px" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_recording" :active-value="1" :inactive-value="0" :width="50" :ref="scope.row.id">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item style="float:right">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">

    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ["data"],
    watch: {
      visible(val) {
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.data));
          // 新增时，数据为undefined，需要初始化
          if (this.form.id === undefined) {
            this.form.period = 240;
            this.form.freq_range = [];
            this.form.whitelist = {};
            this.form.recording_length = 15;
            this.form.detail = "";
          }
          // 获取所有的白名单
          this.searchAllWhitelst({});
          // 隐藏频率编辑
          this.hideFreqInput();
        }
      }
    },
    components: {},
    computed: {},
    methods: {
      show() {
        this.visible = true;
      },

      renderSelect(h) {
        return [
          h("el-checkbox", {
            model: {
              checked: this.checkAll,
              callback: newVal => (this.checkAll = newVal)
            },
            attrs: {
              indeterminate: this.indeterminate
            },
            on: {
              change: this.handleSelectAllChange
            }
          }),
          h("el-badge", {
            attrs: {
              class: "el-badge mark",
              value: this.selectedNum,
              style: "padding:0;margin:0;line-height:23px;"
            }
          })
        ];
      },

      handleSelectAllChange(check) {
        this.indeterminate = false;
        for (let i = 0; i < this.allWhitelst.length; i++) {
          this.allWhitelst[i].checked = check;
        }
        this.selectedNum = check ? this.allWhitelst.length : 0;
      },

      handleCheckChange(check) {
        if (check) {
          this.selectedNum++;
        } else {
          this.selectedNum--;
        }
        this.checkAll = this.selectedNum === this.allWhitelst.length;
        this.indeterminate =
          this.selectedNum > 0 && this.selectedNum < this.allWhitelst.length;
      },

      initSelection() {
        this.selectedNum = 0;
        for (let i = 0; i < this.allWhitelst.length; i++) {
          let row = this.allWhitelst[i];
          let idstr = String(row["id"]);
          if (this.form.whitelist.hasOwnProperty(idstr)) {
            this.allWhitelst[i].is_recording = this.form.whitelist[idstr];
            this.allWhitelst[i].checked = true;
            this.selectedNum++;
          }
        }
        this.checkAll = this.selectedNum === this.allWhitelst.length;
        this.indeterminate =
          this.selectedNum > 0 && this.selectedNum < this.allWhitelst.length;
      },

      parseFreqRange(range) {
        if (range.length == 1) {
          return `${range[0]}`;
        } else {
          return `${range[0]}-${range[1]}`;
        }
      },

      handleTagClose(key) {
        this.form.freq_range.splice(key, 1);
      },

      addFreq() {
        let newRange;
        if (this.freqStart == this.freqEnd) {
          newRange = [this.freqStart];
        } else if (this.freqStart < this.freqEnd) {
          newRange = [this.freqStart, this.freqEnd];
        } else {
          this.$message({
            duration: 2000,
            showClose: true,
            message: "起始频率应小于等于结束频率",
            type: "error"
          });
        }
        if (newRange) {
          if (this.checkFreq(newRange)) {
            this.form.freq_range.push(newRange);
            this.freqInputVisible = false;
            this.freqStart = -1;
            this.freqEnd = -1;
          } else {
            this.$message({
              duration: 2000,
              showClose: true,
              message: "添加失败：与已有频率范围重复",
              type: "error"
            });
          }
        }
      },

      checkFreq(newRange) {
        newRange = JSON.parse(JSON.stringify(newRange));
        if (newRange.length == 1) {
          newRange.push(newRange[0]);
        }
        for (let i = 0; i < this.form.freq_range.length; i++) {
          let range = JSON.parse(JSON.stringify(this.form.freq_range[i]));
          if (range.length == 1) {
            range.push(range[0]);
          }
          if (
            (range[0] <= newRange[1] && range[0] >= newRange[0]) ||
            (range[1] <= newRange[1] && range[1] >= newRange[0])
          ) {
            return false;
          }
        }
        return true;
      },

      hideFreqInput() {
        this.freqInputVisible = false;
        this.freqStart = 0;
        this.freqEnd = 0;
      },

      save() {
        let whiteLst = {};
        for (let i = 0; i < this.allWhitelst.length; i++) {
          if (this.allWhitelst[i].checked) {
            whiteLst[this.allWhitelst[i].id] = this.allWhitelst[i].is_recording;
          }
        }
        this.form.whitelist = whiteLst;
        this.form.create_time = new Date().format("yyyy-MM-dd hh:mm:ss");

        this.visible = false;
        if (this.form.id) {
          this.$getJSON("/task/u_period_tasklst", this.form).then(res => {
            this.$emit("refreshAfterUpdate");
            this.$message({
              type: "success",
              message: "修改成功"
            });
          });
        } else {
          this.$getJSON("/task/i_period_tasklst", this.form).then(res => {
            this.$emit("refreshTable");
            this.$message({
              type: "success",
              message: "添加成功"
            });
          });
        }
      },

      updateForm() {
        let whiteLst = {};
        for (let i = 0; i < this.allWhitelst.length; i++) {
          if (this.allWhitelst[i].checked) {
            whiteLst[this.allWhitelst[i].id] = this.allWhitelst[i].is_recording;
          }
        }
        this.form.whitelist = whiteLst;
        this.form.create_time = new Date().format("yyyy-MM-dd hh:mm:ss");
      },

      searchAllWhitelst(pagesize) {
        this.$getJSON("/task/s_allWhitelst", {
          rows_per_page: pagesize.size,
          current_page: pagesize.page,
          orderby: {
            name: "ASC"
          }
        }).then(res => {
          this.allWhitelst = res.data;
          this.initSelection();
        });
      }
    },
    data() {
      return {
        title: "编辑周期任务",
        visible: false,
        form: {},
        freqInputVisible: false,
        freqStart: 87,
        freqEnd: 108,
        allWhitelst: [],
        size: 10,
        page: 1,
        selectedNum: 0,
        indeterminate: false,
        checkAll: false
      };
    }
  };

</script>
<style scoped>
  .allWhitelstTable {
    height: 30px;
    padding-bottom: 0px;
    margin-bottom: 10px;
  }

  .el-form-item {
    padding-bottom: 0px;
    margin-bottom: 5px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/PeriodTask/Edit.vue